import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { FormatSalarayBasePipe } from 'app/shared/pipes/format-salaray-base.pipe';

import { ContractState } from '@classes/contract/contract-state';
import { Fte } from '@classes/contract/fte';

@Component({
    selector: 'app-state-year',
    templateUrl: './state-year.component.html',
    styleUrls: ['./state-year.component.scss'],
    imports: [
        CommonModule,
        TranslateModule,
        MatTableModule,
        MatTooltip,
        FormatSalarayBasePipe
    ]
})
export class StateYearComponent implements OnChanges {
  @Input() contractStates: ContractState[];
  @Input() fte: Fte[];
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  dataSource: MatTableDataSource<ContractState>;
  displayedColumns: string[] = [
    'dueMonth',
    'fte',
    'scales',
    'scaleSeniority',
    'branch',
    'professionalStatus',
    'scaleAdministrative',
    'seniority',
    'salaryBase'
  ];

  constructor() { }

  ngOnChanges(): void {
    this.dataSource = new MatTableDataSource(this.contractStates);
    this.dataSource.sort = this.sort;
  }

}
